import { RCIcon, RCSegmentedControl } from '@reverbdotcom/cadence/components';
import { RowsIcon, SquaresFourIcon } from '@phosphor-icons/react';
import I18n from 'i18n-js';
import React from 'react';
import { trackEvent } from '../elog/mparticle_tracker';
import { MParticleEventName } from '../elog/mparticle_types';
import { getItem } from '../storage_wrapper';

interface IProps {
  setListViewState?: (val: boolean) => void;
  loading?: boolean;
}
export const LIST_VIEW_STATE = 'LIST_VIEW_STATE';

export default function ListViewToggle({
  setListViewState,
  loading = false,
}: IProps) {
  const listViewState = getItem(LIST_VIEW_STATE) || 'false';

  const onClick = (enabled) => {
    if (listViewState === enabled.toString()) { return; }
    setListViewState(enabled);

    const clickTrackingData = {
      componentName: 'ListViewToggle',
      eventName: MParticleEventName.ClickedListViewToggle,
      usingListView: enabled,
    };

    trackEvent(clickTrackingData);
  };

  const segmentedControlGrid = () => {
    return (
      <RCSegmentedControl.Button
        selected={listViewState === 'false'}
        onClick={() => onClick(false)}
        aria-label={I18n.t('commons.marketplaceViewStates.grid')}
        iconOnly
      >
        <RCIcon icon={<SquaresFourIcon weight="fill" />} />
      </RCSegmentedControl.Button>
    );
  };

  const segmentedControlList = () => {
    return (
      <RCSegmentedControl.Button
        selected={listViewState === 'true'}
        onClick={() => onClick(true)}
        aria-label={I18n.t('commons.marketplaceViewStates.list')}
        iconOnly
      >
        <RCIcon icon={<RowsIcon weight="fill" />} />
      </RCSegmentedControl.Button>
    );
  };

  if (loading) {
    return <RCSegmentedControl.Skeleton/>;
  }

  return (
    <RCSegmentedControl
      aria-label={I18n.t('commons.marketplaceViewStates.ariaLabel')}
      loading={loading}
      size="small"
    >
      {segmentedControlGrid()}
      {segmentedControlList()}
    </RCSegmentedControl>
  );
}
